import { useTranslation } from 'react-i18next';

import { nameToLabel } from 'app/src/elements/forms';

const useTranslateColumnLabels = () => {
  const { i18n, t } = useTranslation();

  const translateColumnLabels = columns => {
    columns.forEach(column => {
      const translationPath = column.labelTranslation || `labels.${column.key}`;

      if (column.label) {
        // NOOP
      } else if (i18n.exists(translationPath)) {
        column.label = t(translationPath);
      } else {
        column.label = nameToLabel(column.key);
      }
    });

    return columns;
  };

  return translateColumnLabels;
};

export default useTranslateColumnLabels;
